declare let grecaptcha: any;

import { UiActions } from './uiActions';

export class Recaptcha {
  helperFunc = new UiActions();

  c  = {
    recapId: "recapId",
    clsRecap: "app-mobius5-recaptcha"
  };

  constructor() { }

  /* 
    Checks if a recaptcha is implemented in the current Form
  */
  async check(wrapper: JQuery): Promise<string | boolean> {
    const recap = wrapper.find("." + this.c.clsRecap);
    // if no recaptcha found, probably ok
    if(recap.length === 0) {
      return true;
    }

    // if many found, probably not ok
    if(recap.length !== 1) {
      throw "recaptcha not found";
    }

    console.log("Recaptcha found, validating...");

    return new Promise((resolve) => {
      grecaptcha.enterprise.ready(async () => {
        const token = await grecaptcha.enterprise.execute(recap.data("sitekey"), {action: 'LOGIN'});
        // return google response for the recap
        resolve(token);
      });
    });
  }
}